import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom"; // Import for routing
import { FaPhoneAlt, FaSearch, FaCheck, FaArrowRight } from "react-icons/fa";
import "../Css/PatientCare.css";
import patientImage from "../assets/service-1.jpg";




const PatientCare = () => {

    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // List of your services
  const services = [
  { name: "Patient Care", path: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", path: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", path: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", path: "/services/cooking-service-in-mumbai" },
  { name: "Driver", path: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", path: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", path: "/services/japa-maid-service-in-mumbai" },
];

  // Filter logic
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  
  return (
    <div className="patientcare-page">
      {/* HERO SECTION - RETAINED AS REQUESTED */}
      <section className="patientcare-hero">
        <div className="patientcare-overlay">
          <div className="patientcare-hero-content">
            <h1>Patient Care</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">Patient Care</span>
            </p>
          </div>
        </div>
      </section>

      {/* SQUARE PREMIUM CONTENT */}
      <section className="main-section">
        <div className="container-square">
          <div className="content-layout">
            
            {/* Main Content Area */}
            <div className="article-box">
              <div className="square-img-holder">
                <img src={patientImage} alt="Patient Care Services" />
                <div className="img-overlay-label">PREMIUM SERVICE</div>
              </div>

              <div className="text-header">
                <h2 className="title-bold">Professional Patient Caretaker in Mumbai</h2>
                <h4 className="subtitle-line">Trusted Patient Care Services in Mumbai</h4>
              </div>

              <div className="body-description">
                <p>Tanya Maid Service is a trusted provider of <b>Patient Care Services in Mumbai</b> and <b>specialized Caretaker Service in Ghatkopar</b>. We are dedicated to offering compassionate, reliable, and professional support for patients and elderly individuals in the comfort of their homes. Our goal is to provide peace of mind to families while ensuring that patients receive the best care possible.</p>
                <p>With a focus on quality and reliability, <b>Tanya Maid Service</b> provides skilled <b>Patient Care Maid in Mumbai</b> who are trained to assist with daily routines, medical requirements, and personal care. Our team understands the delicate nature of patient care and works diligently to create a safe, comfortable, and supportive environment for those in need.</p>
                <p>We offer comprehensive <b>Patient Care Maid Service in Mumbai</b> for individuals recovering from illness, surgery, or those requiring regular assistance due to age or disability. Our maids are compassionate, attentive, and professionally trained to handle various caregiving responsibilities while maintaining respect and dignity for the patient.</p>
              </div>

              {/* Why Choose - Modern Square Grid */}
              <div className="why-choose-square">
                <h3>Why Choose Tanya Maid Service for Caretaker Services?</h3>
                <div className="grid-features">
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Professional Caregivers:</strong> Skilled Patient Car Maid Mumbai to provide assistance with medication, mobility, hygiene, and daily activities.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Reliable & Trustworthy:</strong> All caregivers are background-verified and trained to deliver dependable patient care.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Flexible Services:</strong> Options for full-time, part-time, or hourly caregiving to meet your household’s specific needs.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Caretaker Maid Service:</strong> Offering personalized support tailored to the medical and personal requirements of each patient.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Experienced & Compassionate:</strong> Our Caretaker Maid in Mumbai understand the emotional and physical needs of patients and provide care with empathy.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Continuous Support:</strong> Dedicated customer service to address queries and ensure consistent quality of care.</p>
                  </div>
                </div>
              </div>

              <div className="summary-footer-box">
                <p>At Tanya Maid Service, we understand that every patient's needs are unique. That's why our services are customized to match individual requirements, ensuring comfort, safety, and professional support. Our caregivers assist with mobility, feeding, medication reminders, hygiene, and companionship, making life easier for both patients and their families.</p>
              </div>
            </div>

            {/* Square Sidebar */}
            <aside className="sidebar-square">
              {/* ACTIVE SEARCH BOX */}
      <div className="search-container-premium">
        <div className="search-square">
          <input
            type="text"
            placeholder="SEARCH SERVICES..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button><FaSearch /></button>
        </div>

        {/* Search Results Dropdown */}
        {searchTerm && (
          <div className="search-results-dropdown">
            {filteredServices.length > 0 ? (
              filteredServices.map((service, index) => (
                <div
                  key={index}
                  className="result-item"
                  onClick={() => navigate(service.path)}
                >
                  {service.name}
                </div>
              ))
            ) : (
              <div className="no-result">No services found</div>
            )}
          </div>
        )}
      </div>

              <div className="list-widget">
                <h5>OUR SERVICES</h5>
                <ul className="square-links">
  <li>
    <Link
      to="/services/patient-care-service-in-mumbai"
      className="active-item"
    >
      Patient Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/baby-care-service-in-mumbai">
      Baby Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/house-maid-service-in-mumbai">
      House Maid <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/cooking-service-in-mumbai">
      Cooking <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/driver-service-in-mumbai">
      Driver <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/home-cleaning-service-in-mumbai">
      Home Cleaning <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/japa-maid-service-in-mumbai">
      Japa Maid <FaArrowRight />
    </Link>
  </li>
</ul>
              </div>

<div className="contact-box-square">
  <div className="cta-overlay-square">
    <div className="cta-icon-square">
      <FaPhoneAlt />
    </div>
    <h3 className="cta-title-square">Call us Today!</h3>
    <a href="tel:+917304398067" className="cta-phone-square">
      +91 73043 98067
    </a>
    <a href="mailto:info@tanyamaidservice.com" className="cta-email-square">
      info@tanyamaidservice.com
    </a>
  </div>
</div>
            </aside>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PatientCare;